import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopBilling = dynamic(() => import('../../components/billing/DesktopBilling'), {
  loading: () => <Loading />,
})
const MobileBilling = dynamic(() => import('../../components/billing/MobileBilling'), {
  loading: () => <Loading />,
})
const billing = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>#1 Free Billing Software with GST India | Best POS and Invoice Solutions</title>
        <link rel="canonical" href="https://queuebuster.co/features/billing-software" />
        <link rel="alternate" href="https://queuebuster.co/features/billing-software" hrefLang="en" />
        <meta name="description" content="India #1 free billing software for your business. Enhance your POS billing and invoicing with top GST billing software. Check out the features or take a trial today!" />
        <meta property="og:title" content="#1 Free Billing Software with GST India | Best POS and Invoice Solutions" />
        <meta property="og:description" content="India #1 free POS billing software for your business. Enhance your billing and invoicing with top GST billing software. Check out the features or take a trial today!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG-Image_Billing%2B(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/features/billing-software" />
      </Head>
      <SchemaTags page="billing-software" />
      {mobileView ? <MobileBilling /> : <DesktopBilling />}
    </>
  )
}

export default billing
